import { render, staticRenderFns } from "./promoteHy.vue?vue&type=template&id=30aadab9&scoped=true&"
import script from "./promoteHy.vue?vue&type=script&lang=js&"
export * from "./promoteHy.vue?vue&type=script&lang=js&"
import style0 from "./promoteHy.vue?vue&type=style&index=0&id=30aadab9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aadab9",
  null
  
)

export default component.exports